﻿import { createFileRoute } from "@tanstack/react-router";
import { AnalisesPage } from "@/paginas/pg_franquia/franquia-analises-main";

export const Route = createFileRoute("/_authenticated/analises")({
  head: () => ({
    meta: [
      { title: "Análises — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Central de análises: vendas por período, simulações, tendências, inconsistências e dados de vendas.",
      },
      { property: "og:title", content: "Análises — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Central de análises do controle de estoque da sorveteria.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: AnalisesPage,
});
